export default ($axios) => ({
    getNews() {
        return $axios({
            method: 'GET',
            url: '/base/articles'
        });
    }
});
